const initialState = {
  loading: false,
  data: null,
  error: null,
};

const competitionsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_COMPETITIONS_LIST_REQUEST":
      return { ...state, loading: true, error: null };
    case "FETCH_COMPETITIONS_LIST_SUCCESS":
      return { ...state, loading: false, data: action.payload };
    case "FETCH_COMPETITIONS_LIST_FAILURE":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default competitionsListReducer;
